module.exports = __webpack_public_path__ + "img/Inna-logo-big.1c6bb906.svg";